import PasswordChanged from './PasswordChanged.jsx';

export default PasswordChanged